import {
  MantineProviderProps,
  MantineTheme,
  MantineThemeOverride,
} from '@mantine/styles'

const MantineDefaults: MantineThemeOverride = {
  loader: 'bars',
  // activeStyles: { transform: 'scale(0.80)' },
  cursorType: 'pointer',
  respectReducedMotion: true,
  dateFormat: 'YYYY-MM-DD',

  components: {
    ActionIcon: {
      defaultProps: {
        size: 'xs',
      },
    },

    Checkbox: {
      defaultProps: {
        radius: 'xs',
        size: 'sm',
      },
    },
    Switch: {
      defaultProps: {
        radius: 'md',
        size: 'md',
      },
    },
    Input: {
      defaultProps: {
        size: 'xs',
        radius: 'sm',
      },
      styles: (theme) => ({
        input: {
          '&:disabled': {
            color:
              theme.colorScheme === 'light'
                ? theme.colors.dark[9]
                : theme.colors.gray[5],
            backgroundColor:
              theme.colorScheme === 'light'
                ? theme.colors.gray[4]
                : theme.colors.gray[9],
          },
        },
      }),
    },
    DatePicker: {
      defaultProps: {
        size: 'xs',
        radius: 'sm',
      },
    },
    DatePickerBase: {
      defaultProps: {
        size: 'xs',
        radius: 'sm',
      },
    },
    DateRangePicker: {
      defaultProps: {
        size: 'xs',
        radius: 'sm',
      },
    },
    Button: {
      defaultProps: {
        variant: 'default',
        compact: true,
      },
    },
    Paper: {
      defaultProps: {
        radius: '0',
        p: '0',
        m: '0',
      },
    },
    Accordion: {
      defaultProps: {
        radius: 'xs',
        variant: 'contained',
      },
      styles: (theme) => ({
        item: { padding: '0', margin: '0' },
        itemTitle: { padding: '0' },
        label: { padding: '0', margin: '0' },
        control: { padding: '0.2rem', margin: '0' },
        panel: { padding: '0', margin: '0' },
      }),
    },
  },
}

export { MantineDefaults }
export default MantineDefaults
